import { z } from "zod";
import { ApiDefaultSchema } from "~/api/types";

export const InventorySchemaItem = z.object({
  Count: z.number(),
  Modified: z.string(),
  RechargeDate: z.string(),
  Created: z.string(),
});

export const InventorySchemaItems = z.object({
  Diamonds: InventorySchemaItem,
  Passports: InventorySchemaItem,
  Energy: InventorySchemaItem,
  Hints: InventorySchemaItem,
  "GiftBox.july4th2018_crate": InventorySchemaItem,
  MultiplierFreeToken: InventorySchemaItem,
  "C.Manatee": InventorySchemaItem,
  "C.Cigars": InventorySchemaItem,
  "C.Swimsuit": InventorySchemaItem,
  "C.Wristband": InventorySchemaItem,
  "C.Cubansandwich": InventorySchemaItem,
  "C.Panamahat": InventorySchemaItem,
  "C.Turntables": InventorySchemaItem,
  "C.Towers": InventorySchemaItem,
  "VF.YellowFrame": InventorySchemaItem,
  "C.Towels": InventorySchemaItem,
  "C.Lotion": InventorySchemaItem,
  "VF.BlueFrame": InventorySchemaItem,
  "VF.RedFrame": InventorySchemaItem,
  VowelDetector: InventorySchemaItem,
  SpinUpgradeToken: InventorySchemaItem,
  "C.Yacht": InventorySchemaItem,
  FastPlayFreeEntryToken: InventorySchemaItem,
  Coins: InventorySchemaItem,
  HelpingHand: InventorySchemaItem,
  GoldenHints: InventorySchemaItem,
  "C.Cruiseship": InventorySchemaItem,
  TournamentFreeEntryToken: InventorySchemaItem,
});

export const InventorySchema = ApiDefaultSchema.extend({
  Data: z.object({
    OwnedItems: InventorySchemaItems,
    Version: z.number(),
  }),
});

export type TInventory = z.infer<typeof InventorySchema>;
export type TOwnedItems = z.infer<typeof InventorySchemaItems>;
export type TOwnedItem = z.infer<typeof InventorySchemaItem>;
